var React = require('react');

function Drip (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0.0108638H3.54999C14.47 0.49926 20 12.8177 31.55 10.8641C35.72 10.1695 39.19 7.52133 43.55 7.48877C53.96 7.39109 59.08 20.4258 68.79 22.6833C71.6891 23.4794 74.7527 23.161 77.46 21.7825C79.7642 20.3723 81.7465 18.4175 83.26 16.0628C86.01 12.1665 88.46 7.93373 91.75 4.51496C93.4948 2.5251 95.7081 1.09134 98.15 0.369007C99.0964 0.165272 100.056 0.0418986 101.02 0H105.02","fill":"#FFBC0D"}));
}

Drip.defaultProps = {"width":"106","height":"24","viewBox":"0 0 106 24","fill":"none"};

module.exports = Drip;

Drip.default = Drip;
